import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDAppIDRFW = createAsyncThunk(
    'fetchPDDAppIDRFW',
    async ({ jwtBearer }) => {
        const response = await fetch(`${BASE_URL}pdd/get/app/id/rfw/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddDataRFWSlice = createSlice({
    name: 'pddDataRFWSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDAppIDRFW.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDAppIDRFW.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDAppIDRFW.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddDataRFWSlice.reducer
